var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.name)?_c('svg',{staticClass:"svg-icon",style:(_vm.customStyle),attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":`#icon-${_vm.name}`}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }